import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page-wrapper">
      <main className="flex-shrink-0">

        {/* ========================= HERO SECTION ========================= */}
        <header className="py-5 hero-section min-vh-100 d-flex align-items-center">
          <div className="container px-5">
            <div className="row gx-5 align-items-center">

              {/* Columna izquierda: Texto */}
              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-4 fw-bolder mb-3">
                  Organiza tu vida con CUDA
                </h1>
                <p className="lead fw-normal mb-2 hero-text-muted">
                  Tu asistente personal inteligente disponible 24/7 en Web, Telegram y WhatsApp.
                </p>
                <p className="mb-4 hero-text-muted">
                  Gestiona tareas, recordatorios y consultas con el poder de la IA.
                </p>
                <div className="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-lg-start">
                  <Link className="btn btn-primary btn-lg px-4 me-sm-3" to="/register">
                    Prueba Gratis 15 Días
                  </Link>
                  <a className="btn btn-outline-light btn-lg px-4" href="#features">
                    Saber Más
                  </a>
                </div>
              </div>

              {/* Columna derecha: Imagen del robot */}
              <div className="col-lg-6 d-none d-lg-flex justify-content-end align-items-center">
                <img
                  className="hero-image"
                  src="/assets/hero_robot.png"
                  alt="CUDA Assistant Hero"
                  style={{ maxWidth: '100%' }}
                />
              </div>

            </div>
          </div>
        </header>

        {/* ========================= FEATURES SECTION ========================= */}
        <section className="py-5" id="features">
          <div className="container px-5 my-5">
            <div className="text-center mb-5">
              <h2 className="fw-bolder display-5">Potencia tu día a día</h2>
              <p className="lead fw-normal mb-0" style={{ color: 'rgba(255,255,255,0.85)' }}>
                Simple, inteligente y disponible para cualquiera que quiera organizarse mejor
              </p>
            </div>
            <div className="row gx-5">

              <div className="col-lg-4 mb-5">
                <div className="feature-card h-100 text-center p-4">
                  <img
                    src="/assets/feature_reminders.png"
                    alt="Recordatorios"
                    className="feature-image mb-4"
                  />
                  <div>
                    <h5 className="h4 fw-bold mb-3">Recordatorios Inteligentes</h5>
                    <p className="mb-0 hero-text-muted">
                      Configura alertas con intervalos inteligentes. CUDA te avisará exactamente cuando lo necesites por Telegram o WhatsApp.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 mb-5">
                <div className="feature-card h-100 text-center p-4">
                  <img
                    src="/assets/feature_connectivity.png"
                    alt="Conectividad"
                    className="feature-image mb-4"
                  />
                  <div>
                    <h5 className="h4 fw-bold mb-3">Asistente Directo</h5>
                    <p className="mb-0 hero-text-muted">
                      Acceso total desde el Dashboard web o habla con CUDA en Telegram y WhatsApp como si fuera un contacto más.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 mb-5">
                <div className="feature-card h-100 text-center p-4">
                  <img
                    src="/assets/feature_conversation.png"
                    alt="Conversación"
                    className="feature-image mb-4"
                  />
                  <div>
                    <h5 className="h4 fw-bold mb-3">Memoria Personal</h5>
                    <p className="mb-0 hero-text-muted">
                      CUDA recuerda tus gustos, tu trabajo y tus pasiones para ser cada vez más eficiente.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ========================= PRICING SECTION ========================= */}
        <section className="py-5 pricing-section" id="pricing">
          <div className="container px-5 my-5">
            <div className="text-center mb-5">
              <h2 className="fw-bolder display-4">Elige tu Plan</h2>
              <p className="lead mb-0" style={{ color: 'rgba(255,255,255,0.85)' }}>
                Empezá gratis y escalá cuando quieras. Sin compromisos.
              </p>
            </div>
            <div className="row gx-5 justify-content-center align-items-stretch">

              {/* Plan Medio */}
              <div className="col-lg-6 col-xl-4 mb-5">
                <div className="card shadow-lg border-0 h-100">
                  <div className="card-body p-5 d-flex flex-column">
                    <div className="small text-uppercase fw-bold">Medio</div>
                    <div className="mb-3 text-center">
                      <span className="display-4 fw-bold">$5</span>
                      <span className="text-muted">/ mes.</span>
                    </div>
                    <ul className="list-unstyled mb-4 flex-grow-1">
                      <li className="mb-2">
                        <i className="bi bi-check2-circle me-2" style={{ color: 'var(--cuda-dark-title)' }}></i>
                        Acceso Web, Telegram y WhatsApp
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check2-circle me-2" style={{ color: 'var(--cuda-dark-title)' }}></i>
                        Recordatorios Proactivos
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check2-circle me-2" style={{ color: 'var(--cuda-dark-title)' }}></i>
                        Hasta 35 mensajes por mes
                      </li>
                    </ul>
                    <div className="d-grid">
                      <Link className="btn btn-primary" to="/pricing?plan=MEDIO">
                        Adquirir Plan Medio
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Plan Full */}
              <div className="col-lg-6 col-xl-4 mb-5">
                <div className="card shadow-lg border-0 h-100">
                  <div className="card-body p-5 d-flex flex-column">
                    <div className="small text-uppercase fw-bold">Full</div>
                    <div className="mb-3 text-center">
                      <span className="display-4 fw-bold">$10</span>
                      <span className="text-muted">/ mes.</span>
                    </div>
                    <ul className="list-unstyled mb-4 flex-grow-1">
                      <li className="mb-2">
                        <i className="bi bi-star-fill me-2" style={{ color: '#ffc107' }}></i>
                        Mensajes Ilimitados
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check2-circle me-2" style={{ color: 'var(--cuda-dark-title)' }}></i>
                        Personalización e Instrucciones
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check2-circle me-2" style={{ color: 'var(--cuda-dark-title)' }}></i>
                        Soporte Técnico Prioritario
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-check2-circle me-2" style={{ color: 'var(--cuda-dark-title)' }}></i>
                        Memoria de Largo Plazo
                      </li>
                    </ul>
                    <div className="d-grid">
                      <Link className="btn btn-primary" to="/pricing?plan=FULL">
                        Ir por todo con Full
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* Botón de prueba gratis adicional */}
            <div className="d-flex justify-content-center mt-3">
              <Link className="btn btn-primary btn-lg px-5 btn-pricing-trial" to="/register">
                O probalo gratis por 15 días
              </Link>
            </div>

          </div>
        </section>

        {/* ========================= FAQ SECTION ========================= */}
        <section className="py-5 faq-section" id="faq">
          <div className="container px-5 my-5">
            <div className="text-center mb-5">
              <h2 className="fw-bolder display-5">Preguntas Frecuentes</h2>
              <p className="lead mb-0" style={{ color: 'rgba(255,255,255,0.85)' }}>
                Todo lo que necesitas saber sobre CUDA y su funcionamiento.
              </p>
            </div>
            <div className="row gx-5 justify-content-center">
              <div className="col-lg-8">
                
                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Qué es CUDA y cómo me ayuda?</h4>
                  <p className="mb-0 hero-text-muted">
                    CUDA es tu asistente personal inteligente 24/7. Te ayuda a organizar tu día a día gestionando recordatorios inteligentes, guardando notas de voz, analizando imágenes de recibos o fechas importantes, y manteniendo una memoria de tus preferencias y actividades.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Cómo hablo con CUDA en WhatsApp y Telegram?</h4>
                  <p className="mb-0 hero-text-muted">
                    Una vez registrado, puedes ir a tu Dashboard en la web y hacer clic en "Vincular WhatsApp" o "Vincular Telegram". Recibirás un token de vinculación de un solo uso que envías al asistente en la app de mensajería, y a partir de ese momento CUDA te responderá directamente allí.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Qué son los recordatorios con intervalos inteligentes?</h4>
                  <p className="mb-0 hero-text-muted">
                    Cuando agendas un recordatorio, puedes pedirle a CUDA que te avise varias veces con anticipación (por ejemplo, 4 horas antes, 1 hora antes y al momento del evento). CUDA te enviará mensajes proactivos por Telegram o WhatsApp para que nunca olvides nada importante.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Puedo conectar mi Google Calendar?</h4>
                  <p className="mb-0 hero-text-muted">
                    ¡Sí! Desde la configuración de tu cuenta puedes sincronizar tu Google Calendar. CUDA podrá leer tus eventos programados de Google, crear nuevos eventos por ti desde el chat mediante lenguaje natural y eliminar los que ya no necesites.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿CUDA puede buscarme contactos?</h4>
                  <p className="mb-0 hero-text-muted">
                    ¡Sí! Si vinculas tu cuenta de Google, CUDA podrá buscar en tus Google Contacts para obtener números de teléfono o correos. Si el contacto no está en Google, también puede buscarlo dentro de tu agenda de WhatsApp para ayudarte a enviar un mensaje o agendar algo rápidamente.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Puedo cambiarle el nombre al asistente o aparece como CUDA?</h4>
                  <p className="mb-0 hero-text-muted">
                    ¡Sí! Puedes cambiar el nombre de tu asistente y asignarle el que prefieras (por ejemplo, "asistente Natalia") desde los ajustes de tu Dashboard web. El asistente responderá identificándose con ese nombre y adaptará sus interacciones de manera personalizada.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Cómo funciona la memoria de largo plazo?</h4>
                  <p className="mb-0 hero-text-muted">
                    CUDA tiene una memoria contextual permanente. A medida que hablas con él, recuerda detalles sobre ti (como tus pasiones, fechas especiales, instrucciones de cómo prefieres que te responda o datos profesionales). Puedes actualizar esta información o pedirle que recuerde cosas específicas en cualquier momento.
                  </p>
                </div>

                <div className="faq-card mb-4 p-4">
                  <h4 className="fw-bold mb-2">¿Qué pasa si me quedo sin mensajes en mi plan?</h4>
                  <p className="mb-0 hero-text-muted">
                    Cada plan tiene un límite de interacciones mensuales. Si alcanzas el límite, el asistente te notificará de forma amigable. Puedes actualizar a un plan superior (como el plan Full con mensajes ilimitados) directamente desde el Dashboard web en cualquier momento.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </section>

      </main>
    </div>
  );
};

export default LandingPage;
